import styled, { css } from 'styled-components'

import Dropdown from 'components/Dropdown'
import Pill from 'components/Pill'

import { ProjectsHeader as BaseProjectsHeader } from 'modules/projects/components'

export const MenuWrapper = styled.div`
  padding: 16px 8px;
  width: 100%;
  flex: 1;
  overflow-y: auto;
`

export const DropdownDivider = styled(Dropdown.Divider)`
  margin: 8px -8px;
`

export const FooterWrapper = styled.div`
  padding: 8px;
  border-top: 1px solid ${({ theme }) => theme.colors.border[2]};
`

export const DropdownItem = styled.li`
  list-style: none;
`

export const StyledPill = styled(Pill)`
  margin-left: auto;
  margin-right: 12px;

  .active & {
    background-color: ${({ theme }) => theme.colors.primaryTint[10]};
    color: ${({ theme }) => theme.colors.primaryTint[100]};
  }
`

export const WorkspaceHeader = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.foreground.secondary[4]};
    font-size: ${theme.fontSizes.tiny};
    font-weight: ${theme.fontWeights.semibold};
    text-transform: uppercase;
    margin: 26px 12px 10px;
  `}
`

export const ProjectsHeader = styled(BaseProjectsHeader)`
  margin-top: 30px; /* stylelint-disable-line scales/space */
  margin-bottom: 10px; /* stylelint-disable-line scales/space */
`

export const WorkspaceSelectorWrapper = styled.aside`
  border-bottom: 1px solid ${({ theme }) => theme.colors.alto};
`

export const ProjectsMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;

  /* Limit the components width, preventing items with big name to have scroll */
  width: 100%;
  /* Enables scroll on the sidebar instead on the frame, causing double scrollbars
  in some scenarios. More info: https://github.com/sketch-hq/Cloud/issues/9511 */
  height: 100%;
  flex: 1;

  background-color: ${({ theme }) => theme.colors.background.light.secondary};
`

export const SettingsWrapper = styled.aside`
  border-top: 1px solid ${({ theme }) => theme.colors.alto};
  padding: 5px 8px; /* stylelint-disable-line scales/space */
`
